import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractStateContextComponent } from './state-context/state-context.component';
import { SvgsModule } from '../svgs/svgs.module';
import { InitialStateComponent } from './initial/initial.state';
import { FailureStateComponent } from './failure/failure.state';
import { ReceivedStateComponent } from './received/received.state';
import { GeneratedStateComponent } from './generated/generated.state';
import { BaseComponent } from './base/base.component';
import { UploadingStateComponent } from './uploading/uploading.state';
import { UiModule } from '../ui/ui.module';
import { ContractStateDirective } from './state-context/state-context.directive';
///------------------------------------------------------------------------------------------
@NgModule({
  declarations: [
    ContractStateDirective,
    ContractStateContextComponent,
    BaseComponent,
    InitialStateComponent,
    GeneratedStateComponent,
    UploadingStateComponent,
    FailureStateComponent,
    ReceivedStateComponent
  ],
  imports: [
    CommonModule,
    SvgsModule,
    UiModule,
  ],
  exports: [
    ContractStateContextComponent
  ],
  entryComponents : [
    InitialStateComponent,
    GeneratedStateComponent,
    UploadingStateComponent,
    FailureStateComponent,
    ReceivedStateComponent,
  ]
})
export class ContractStateModule { }
